import './App.css';
import { useAuth } from "react-oidc-context";
import Dashboard from './Dashboard';
import { Routes, Route, Navigate } from 'react-router-dom'; // Import routing components
import AuthCallback from './AuthCallback'; // Import the new callback component

// A helper component to protect routes
function ProtectedRoute({ children }) {
  const auth = useAuth();
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }
  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }
  return auth.isAuthenticated ? children : <Navigate to="/login" replace />;
}

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    const clientId = "1ep6l8f3vq2bmasp6okpgat5sp";
    const logoutUri = process.env.NODE_ENV === 'production'
      ? 'https://compute.ocklet.com'
      : 'http://localhost:3000';
    const cognitoDomain = "https://us-east-2b0vanqjif.auth.us-east-2.amazoncognito.com";
    // Important: removeUser clears the local session
    auth.removeUser().then(() => {
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    });
  };

  return (
    <Routes>
      {/* Route for the login page */}
      <Route path="/login" element={
        <div className="login-container">
          <button onClick={() => auth.signinRedirect()}>Sign in</button>
        </div>
      } />

      {/* Route for the OIDC callback */}
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Protected route for the dashboard */}
      <Route path="/" element={
        <ProtectedRoute>
          <div className="dashboard-container">
            <Dashboard auth={auth}/>
            <button onClick={signOutRedirect}>Sign out</button>
          </div>
        </ProtectedRoute>
      } />

      {/* Optional: A route to redirect users if they start at the root */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;